var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.597 9.25L9.256 14.59C9.11763 14.7285 8.95332 14.8383 8.77247 14.9133C8.59162 14.9882 8.39777 15.0268 8.202 15.0268C8.00623 15.0268 7.81238 14.9882 7.63153 14.9133C7.45068 14.8383 7.28637 14.7285 7.148 14.59L0.75 8.199V0.75H8.199L14.599 7.15C14.876 7.4294 15.0312 7.80699 15.0308 8.20041C15.0305 8.59383 14.8745 8.97113 14.597 9.25Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 1.5,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.913,
    height: 15.776,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.d88e6ebf27814fa99bdd16f85454f9ce.svg";
export { ForwardRef as ReactComponent };